import React from 'react';
import Typography from '@mui/material/Typography';
import {useTheme} from '@mui/material/styles';
import {keyframes} from '@emotion/react';


interface Props {
    label: string | undefined;
    value: string | number | undefined;
    upperCaseValue?: boolean,
    italic?: boolean;
    fontSize?: string | number;
    valueColor?: string;
    bold?: boolean;
    pulse?: boolean;
}

const LabelledMuiTypography: React.FC<Props> = ({
                                                    label,
                                                    value,
                                                    italic,
                                                    upperCaseValue = false,
                                                    fontSize = 20,
                                                    valueColor,
                                                    bold = false,
                                                    pulse = false
                                                }) => {
    const theme = useTheme();

    const pulseAnim = keyframes`
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.25);
        }
        100% {
            transform: scale(1);
        }
    `;

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', letterSpacing: 'widest'}}>
            {label && <Typography variant="body1"
                                  sx={{
                                      textTransform: 'capitalize',
                                      fontSize: fontSize,
                                      color: theme.palette.textAppGarageColor.tw500
                                  }}>{(label)}: </Typography>}
            <Typography
                sx={{
                    color: valueColor ?? theme.palette.textAppGarageColor.tw700,
                    paddingX: 1,
                    fontSize: fontSize,
                    fontStyle: italic ? 'italic' : 'normal',
                    fontWeight: bold ? 'bold' : 'normal',
                    textTransform: upperCaseValue ? 'uppercase' : '',
                    animation: pulse ? `${pulseAnim} 1.2s ease-in-out infinite` : 'none',
                    display: 'inline-block'
                }}
            >
                {value !== undefined ? (value.toString()) : null}
            </Typography>
        </div>
    );

};

export default LabelledMuiTypography;
